import Axios from './axios_wrapper'

export function getLanguages() {
  return Axios({
    url: '/locales',
    method: 'GET'
  })
}

export function createLanguage(data) {
  return Axios({
    url: `/admin/csv/locales`,
    method: 'POST',
    type: 'NOTYPE',
    data
  })
}

export function updateLocaleName(localeId, data) {
  return Axios({
    url: `/locales/${localeId}`,
    method: 'PATCH',
    data
  })
}

export function getCSVTemplate(localeId, localeCode) {
  return Axios({
    url: `/admin/csv/locales/${localeId}?locale_code=${localeCode}`,
    method: 'GET'
  })
}

export function getCSVSampleTemplate() {
  return Axios({
    url: `/admin/csv/locales/sample`,
    method: 'GET'
  })
}

export function deleteLanguage(localeId) {
  return Axios({
    url: `/locales/${localeId}`,
    method: 'DELETE'
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/languages.js
// module id = null
// module chunks = 